module.exports = __webpack_public_path__ + "static/media/video.e0613114.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyTurfClub/video.mp4
// module id = 208
// module chunks = 0